module.exports = __webpack_public_path__ + "img/terrace2.0daf1f5b.png";